import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import parse from 'html-react-parser';

import { CheckboxChangeEventTarget } from 'antd/lib/checkbox/Checkbox';
import { Checkbox } from 'antd';
import { FormattedMessage } from 'react-intl';

import { ICondoBookingSummary, RefundableEnum } from '@common-types';
import { InfoSvg } from '@assets';

import './style.scss';

interface IProps {
  condoBookingSummary: ICondoBookingSummary;

  displayCheckbox: boolean;
  disable: boolean;
  
  onChangeAcceptPolicy: (e: { target: CheckboxChangeEventTarget }) => void;
}

const ZERO = 0;

export class CondoCancellationPolicies extends React.Component<IProps, null> {
  isWeeksResortCheckInDays = (): boolean => {
    const { daysOfCheckIn } = this.props.condoBookingSummary.bookingPolicies;

    return (
      !isUndefined(daysOfCheckIn) &&
      !isUndefined(daysOfCheckIn.weeksResortCheckInDays) &&
      !isEmpty(daysOfCheckIn.weeksResortCheckInDays)
    );
  };

  isDefaultTextWeeksResortCheckInDays = (): boolean => {
    const { daysOfCheckIn } = this.props.condoBookingSummary.bookingPolicies;

    return (
      !isUndefined(daysOfCheckIn) &&
      !isUndefined(daysOfCheckIn.pointsResortCheckInDays) &&
      !isEmpty(daysOfCheckIn.pointsResortCheckInDays) &&
      (isUndefined(daysOfCheckIn.weeksResortCheckInDays) ||
        isEmpty(daysOfCheckIn.weeksResortCheckInDays))
    );
  };

  isPointsResortCheckInDays = (): boolean => {
    const { daysOfCheckIn } = this.props.condoBookingSummary.bookingPolicies;

    return (
      !isUndefined(daysOfCheckIn) &&
      !isUndefined(daysOfCheckIn.pointsResortCheckInDays) &&
      !isEmpty(daysOfCheckIn.pointsResortCheckInDays)
    );
  };

  isCheckInTime = (): boolean => {
    const { checkInCheckOutInfo } = this.props.condoBookingSummary.bookingPolicies;

    return !isUndefined(checkInCheckOutInfo) && !isUndefined(checkInCheckOutInfo.checkInTime);
  };

  isCheckOutTime = (): boolean => {
    const { checkInCheckOutInfo } = this.props.condoBookingSummary.bookingPolicies;

    return !isUndefined(checkInCheckOutInfo) && !isUndefined(checkInCheckOutInfo.checkOutTime);
  };

  isPossibleApplicableFees = (): boolean => {
    const { bookingBeforeYouGo } = this.props.condoBookingSummary;

    return (
      !isEmpty(bookingBeforeYouGo.mandatoryFees) ||
      !isEmpty(bookingBeforeYouGo.fees) ||
      !isEmpty(bookingBeforeYouGo.housekeepingFees)
    );
  };

  isKnowBeforeYouGo = (): boolean => {
    const { bookingBeforeYouGo } = this.props.condoBookingSummary;

    return (
      !isEmpty(bookingBeforeYouGo.urgentInfo) || !isEmpty(bookingBeforeYouGo.constructionDetails)
    );
  };

  getExpressCheckInCheckOut = (): boolean => {
    const { checkInCheckOutInfo } = this.props.condoBookingSummary.bookingPolicies;

    return (
      !isUndefined(checkInCheckOutInfo.expressCheckInCheckOut) &&
      !isEmpty(checkInCheckOutInfo.expressCheckInCheckOut) &&
      checkInCheckOutInfo.expressCheckInCheckOut
    );
  };

  render(): React.ReactNode {
    const { condoBookingSummary, disable, displayCheckbox, onChangeAcceptPolicy } = this.props;
    const { bookingPolicies, bookingBeforeYouGo, refundability } = condoBookingSummary;

    const { checkInCheckOutInfo } = bookingPolicies;

    const isRefundable = refundability === RefundableEnum.Refundable;

    return (
      <div className="condo-cancellation-policies">
        <h4 className="condo-cancellation-policies__title">
          <FormattedMessage id="important.information" />
        </h4>
        {this.isCheckInTime() ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="check.in" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <p className="condo-cancellation-policies__info-text bold">
                {checkInCheckOutInfo.checkInTime}
              </p>
              {!isUndefined(checkInCheckOutInfo.arrivalCheckInSpecialInstructions) ||
                (!isEmpty(checkInCheckOutInfo.arrivalCheckInSpecialInstructions) && (
                  <p className="condo-cancellation-policies__info-text">
                    {checkInCheckOutInfo.arrivalCheckInSpecialInstructions}
                  </p>
                ))}
              {this.getExpressCheckInCheckOut() && (
                <p className="condo-cancellation-policies__info-text">
                  <FormattedMessage id="express.check.in.check.out" />
                </p>
              )}
            </div>
          </div>
        ) : null}
        {this.isCheckOutTime() ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="check.out" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <p className="condo-cancellation-policies__info-text bold">
                {checkInCheckOutInfo.checkOutTime}
              </p>
              {!isUndefined(checkInCheckOutInfo.afterHoursInstructions) ||
                (!isEmpty(checkInCheckOutInfo.afterHoursInstructions) && (
                  <p className="condo-cancellation-policies__info-text">
                    {checkInCheckOutInfo.afterHoursInstructions}
                  </p>
                ))}
              {!isUndefined(checkInCheckOutInfo.description) ||
                (!isEmpty(checkInCheckOutInfo.description) && (
                  <p className="condo-cancellation-policies__info-text">
                    {checkInCheckOutInfo.description}
                  </p>
                ))}
            </div>
          </div>
        ) : null}
        {!isUndefined(bookingPolicies.ageRestriction) &&
        !isEmpty(bookingPolicies.ageRestriction) ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="age.restriction" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <p className="condo-cancellation-policies__info-text">
                {bookingPolicies.ageRestriction}
              </p>
            </div>
          </div>
        ) : null}
        {this.isWeeksResortCheckInDays() ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="weekly.stays" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <div className="condo-cancellation-policies__info-text-wrapper">
                {bookingPolicies.daysOfCheckIn.weeksResortCheckInDays.map((item, index) => (
                  <p key={index} className="condo-cancellation-policies__info-text bold">
                    {item}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ) : null}
        {this.isDefaultTextWeeksResortCheckInDays() ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="weekly.stays" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <div className="condo-cancellation-policies__info-text-wrapper">
                <FormattedMessage id="not.returned.days.of.check.in.for.weekly" />
              </div>
            </div>
          </div>
        ) : null}
        {this.isPointsResortCheckInDays() ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="short.stays" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <div className="condo-cancellation-policies__info-text-wrapper">
                {bookingPolicies.daysOfCheckIn.pointsResortCheckInDays.map((item, index) => (
                  <p key={index} className="condo-cancellation-policies__info-text bold">
                    {item}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ) : null}
        {bookingPolicies.minimumNights > ZERO && (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="minimum.night.stay" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <p className="condo-cancellation-policies__info-text bold">
                {bookingPolicies.minimumNights}
              </p>
            </div>
          </div>
        )}
        {!isUndefined(bookingPolicies.frontDeskInfo) && !isEmpty(bookingPolicies.frontDeskInfo) ? (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="front.desk.info" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <p className="condo-cancellation-policies__info-text bold">
                {bookingPolicies.frontDeskInfo.hoursOfOperationStartTime} -{' '}
                {bookingPolicies.frontDeskInfo.hoursOfOperationEndTime}
              </p>
              {bookingPolicies.frontDeskInfo.resortFrontDeskInfoIs24Hours && (
                <p className="condo-cancellation-policies__info-text bold">
                  <FormattedMessage id="24.hours" />
                </p>
              )}
              {bookingPolicies.frontDeskInfo.resortFrontdeskInfoIsOnsite && (
                <p className="condo-cancellation-policies__info-text bold">
                  <FormattedMessage id="onsite" />
                </p>
              )}
            </div>
          </div>
        ) : null}
        {!isEmpty(bookingPolicies.pets) && (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="pets" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              <p className="condo-cancellation-policies__info-text">{bookingPolicies.pets}</p>
            </div>
          </div>
        )}
        {!isEmpty(bookingPolicies.parking) && (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="parking" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              {bookingPolicies.parking.map((item, index) => (
                <p key={index} className="condo-cancellation-policies__info-text">
                  {item}
                </p>
              ))}
            </div>
          </div>
        )}
        {!isEmpty(bookingPolicies.smoking) && (
          <div className="condo-cancellation-policies__info">
            <p className="condo-cancellation-policies__point">
              <FormattedMessage id="smoking" />:
            </p>
            <div className="condo-cancellation-policies__info-text-wrapper">
              {bookingPolicies.smoking.map((item, index) => (
                <p key={index} className="condo-cancellation-policies__info-text">
                  {item}
                </p>
              ))}
            </div>
          </div>
        )}
        {this.isKnowBeforeYouGo() || this.isPossibleApplicableFees() ? (
          <div className="condo-cancellation-policies__know-wrapper">
            {!isEmpty(bookingBeforeYouGo.urgentInfo) && (
              <div className="condo-cancellation-policies__know-block">
                <h4 className="condo-cancellation-policies__know-title">
                  <InfoSvg />
                  <FormattedMessage id="know.before.you.go" />
                </h4>
                {!isEmpty(bookingBeforeYouGo.urgentInfo.generalUrgentInfoMessages) && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    {bookingBeforeYouGo.urgentInfo.generalUrgentInfoMessages.map((item, index) => (
                      <p key={index} className="condo-cancellation-policies__know--text">
                        {parse(item)}
                      </p>
                    ))}
                  </div>
                )}
                {!isEmpty(bookingBeforeYouGo.urgentInfo.generalUrgentInfoForNonMembersMessages) && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    {bookingBeforeYouGo.urgentInfo.generalUrgentInfoForNonMembersMessages.map(
                      (item, index) => (
                        <p key={index} className="condo-cancellation-policies__know--text">
                          {parse(item)}
                        </p>
                      ),
                    )}
                  </div>
                )}
                {bookingBeforeYouGo.urgentInfo.occupancyRestrictions && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      {parse(bookingBeforeYouGo.urgentInfo.occupancyRestrictions)}
                    </p>
                  </div>
                )}
                {bookingBeforeYouGo.urgentInfo.oneInXRuleApplies && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      {parse(bookingBeforeYouGo.urgentInfo.oneInXRuleApplies)}
                    </p>
                  </div>
                )}
                {bookingBeforeYouGo.urgentInfo.separateSwimmingPoolForGenders && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      <FormattedMessage id="separate.swimming.pool.for.genders" />
                    </p>
                  </div>
                )}
                {bookingBeforeYouGo.urgentInfo.alcoholRestricted && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      <FormattedMessage id="alcohol.restricted" />
                    </p>
                  </div>
                )}
                {bookingBeforeYouGo.urgentInfo.alcoholServedOnsite && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      <FormattedMessage id="alcohol.served.onsite" />
                    </p>
                  </div>
                )}
                {bookingBeforeYouGo.urgentInfo.resortStayRestrictionsInfo && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      {parse(bookingBeforeYouGo.urgentInfo.resortStayRestrictionsInfo)}
                    </p>
                  </div>
                )}
              </div>
            )}
            {this.isPossibleApplicableFees() && (
              <div className="condo-cancellation-policies__know-block">
                <h4 className="condo-cancellation-policies__know-title">
                  <FormattedMessage id="possible.applicable.fees" />
                </h4>
                {!isEmpty(bookingBeforeYouGo.mandatoryFees) && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    {bookingBeforeYouGo.mandatoryFees.map((item, index) => (
                      <div key={index} className="condo-cancellation-policies__know-text-block">
                        {item.infoMessage && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.infoMessage)}
                          </p>
                        )}
                        {item.additionalInfoMessage && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.additionalInfoMessage)}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {!isEmpty(bookingBeforeYouGo.fees) && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    {bookingBeforeYouGo.fees.map((item, index) => (
                      <div key={index} className="condo-cancellation-policies__know-text-block">
                        {item.infoMessage && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.infoMessage)}
                          </p>
                        )}
                        {item.additionalInfoMessage && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.additionalInfoMessage)}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {!isEmpty(bookingBeforeYouGo.housekeepingFees) && (
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    {bookingBeforeYouGo.housekeepingFees.map((item, index) => (
                      <div key={index} className="condo-cancellation-policies__know-text-block">
                        {item.feeSchedule && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.feeSchedule)}
                          </p>
                        )}
                        {item.infoMessage && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.infoMessage)}
                          </p>
                        )}
                        {item.additionalInfoMessage && (
                          <p className="condo-cancellation-policies__know--text">
                            {parse(item.additionalInfoMessage)}
                          </p>
                        )}
                        {item.mandatoryFee && (
                          <p className="condo-cancellation-policies__know--text">
                            <FormattedMessage id="mandatory.fee" />
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {!isEmpty(bookingBeforeYouGo.constructionDetails) && (
              <div className="condo-cancellation-policies__know-block">
                <h4 className="condo-cancellation-policies__know-title">
                  <FormattedMessage id="resort.construction.restrictions" />
                </h4>
                <div className="condo-cancellation-policies__know-text-wrapper">
                  {bookingBeforeYouGo.constructionDetails.map((item, index) => (
                    <div key={index}>
                      {item.startDate && item.endDate && (
                        <p className="condo-cancellation-policies__know--text">
                          {item.startDate} - {item.endDate}
                        </p>
                      )}
                      {item.infoMessage && (
                        <p className="condo-cancellation-policies__know--text">
                          {item.infoMessage}
                        </p>
                      )}
                      {item.additionalInfoMessage && (
                        <p className="condo-cancellation-policies__know--text">
                          {item.additionalInfoMessage}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!isEmpty(bookingBeforeYouGo.amenityClosures) && (
              <div className="condo-cancellation-policies__know-block">
                <h4 className="condo-cancellation-policies__know-title">
                  <FormattedMessage id="resort.construction.restrictions" />
                </h4>
                <div className="condo-cancellation-policies__know-text-wrapper">
                  {bookingBeforeYouGo.amenityClosures.map((item, index) => (
                    <div key={index}>
                      {item.startDate && item.endDate && (
                        <p className="condo-cancellation-policies__know--text">
                          {item.startDate} - {item.endDate}
                        </p>
                      )}
                      {item.infoMessage && (
                        <p className="condo-cancellation-policies__know--text">
                          {item.infoMessage}
                        </p>
                      )}
                      {item.additionalInfoMessage && (
                        <p className="condo-cancellation-policies__know--text">
                          {item.additionalInfoMessage}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!isUndefined(bookingBeforeYouGo.specialNotesPrecautions) &&
              !isEmpty(bookingBeforeYouGo.specialNotesPrecautions) && (
                <div className="condo-cancellation-policies__know-block">
                  <h4 className="condo-cancellation-policies__know-title">
                    <FormattedMessage id="special.notes.precautions" />
                  </h4>
                  <div className="condo-cancellation-policies__know-text-wrapper">
                    <p className="condo-cancellation-policies__know--text">
                      {bookingBeforeYouGo.specialNotesPrecautions}
                    </p>
                  </div>
                </div>
              )}
          </div>
        ) : null}

        {!isEmpty(condoBookingSummary.cancellationPolicyText) ? (
          <div className="condo-cancellation-policies__policies-text-wrapper">
            <div className="condo-cancellation-policies__policies-header">
              <h4 className="condo-cancellation-policies__title-text">
                <FormattedMessage id="cancellation.policy" />
              </h4>
              <div className="unit-main-info__refundable" style={{ display: 'inline-block' }}>
                <div className="unit-main-info__refundable" style={{ display: 'inline-block' }}>
                  <div className={isRefundable ? 'unit-main-info__refundable-ref' : 'unit-main-info__refundable-nonref'} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>
                      <FormattedMessage id={isRefundable ? 'refundable' : 'non.refundable'} />
                    </span>
                    <InfoSvg />
                  </div>
                </div>);
              </div>
            </div>

            <p className="condo-cancellation-policies__policies-text" style={{ marginTop: '10px' }}>
              {condoBookingSummary.cancellationPolicyText}
            </p>

            <p className="condo-cancellation-policies__policies-text">
              <FormattedMessage id="no-refundble.acknowledge" />
            </p>

            {displayCheckbox ? (
              <div className="review-book__wrapper" style={{ flexDirection: 'row' }}>
                <Checkbox onChange={onChangeAcceptPolicy} disabled={disable} />
                <p className="review-book__accept-text">
                  <FormattedMessage id="by.checking.this.box.you.acknowledge.cancellation.policy" />
                </p>
              </div>) : null}
          </div>
        ) : null}
      </div>
    );
  }
}
